import { useAuthSelector } from 'app/data/auth';
import menuQueryKeys from 'app/hooks/queries/menu/menuQueryKeys';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { MediasPageResponse } from 'types/media';
import { MenusPageResponse } from 'types/menu';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  options?: Omit<
    UseQueryOptions<MenusPageResponse, Error, MenusPageResponse, QueryKey>,
    'queryKey' | 'queryFn'
  >;
}

export const useListMenusQuery = ({
  skip = 0,
  take = 10000,
  orderBy = [['name', 'asc']],
  filters = {},
  options,
}: QueryParams) => {
  // returns list of menus
  // - just get ALL menus+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = menuQueryKeys.list(skip, take, orderBy, filters);

  const query = useQuery<MenusPageResponse, Error>(
    queryKey,
    () =>
      sdk.menu.query.menus(
        {
          skip,
          take,
          orderBy,
          filters,
        },
        { authToken: authState.auth_token },
      ),
    {
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,

      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
      ...options,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useListMenusQuery;
